import { Theme, ThemeProvider } from 'theme-ui';
import { ReactNode, useMemo } from 'react';
import { useMainTheme } from './methods/useMainTheme';
import { TCustomPalette, TThemeModifier } from './base/colors/types';

interface TThemeProvider {
  children: ReactNode;
  customTheme?: () => Omit<Theme, 'palette'>;
  customPalette?: () => TCustomPalette | undefined;
  themeModifier?: TThemeModifier;
}

let timeout = -1;
function logTheme(theme: unknown) {
  clearTimeout(timeout);
  timeout = setTimeout(() => {
    console.info('Theme log: ', { theme });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, 500) as any;
}

export const ApiaThemeProvider = ({
  children,
  customTheme,
  customPalette,
  themeModifier,
}: TThemeProvider) => {
  const parsedCustomPalette = useMemo(() => {
    return customPalette?.();
  }, [customPalette]);

  const theme: Theme = useMainTheme(
    customTheme,
    parsedCustomPalette,
    themeModifier,
  );

  logTheme(theme);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
